(() => {
	angular.module('main').directive('addMailOrTemplate', addMailOrTemplate);

	addMailOrTemplate.$inject = [
		'templateRequestsService',
		'messageService',
		'validationService',
		'emailService'
	];

	function addMailOrTemplate(
		templateRequestsService,
		messageService,
		validationService,
		emailService
	) {
		return {
			restrict: 'E',
			scope: {
				emailToSave: '=',
				emailInfo: '<',
				emailTemplates: '<'
			},
			template: ` <div>
                            <div class="field-info">
                                <h4>Choose email template</h4>

                                <div class="flex-row flex-just-space flex-wrap-md">
                                    <div class="flex-basis-55-md  flex-basis-full-sm">
                                        <div class="select-style">
                                            <select ng-model="selectedEmail"
                                                    ng-required="!emailInfo.isEmailShown"
                                                    ng-change="getEmailTemplate(selectedEmail)"
                                                    ng-disabled = "!emailTemplates.length"
                                                    ng-options="template.name for template in emailTemplates | orderBy track by template.name">
                                                    <option value="">Choose an existing email template</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="flex-row just-center-sm flex-basis-full-sm">
                                        <h4>OR</h4>
                                        </div>
                                        <div class="flex-row just-center-sm flex-basis-full-sm">
                                             <button type="button" ng-disabled="button_disable"
                                                        ng-click="addNewTemplate()"
                                                        class="btn btn-info btn-add-new-sm mb-0">Add new email template
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            <div class="field-info" ng-if="emailInfo.isEmailShown">
                                <h4>Name</h4>
                                <div class="flex-row">
                                    <input ng-disabled="button_disable" type="text" class="form-control" required
                                           placeholder="Give this email template a name" autocomplete="off"
                                           ng-model="newEmailTemplate.name">
                                </div>
                            </div>

                        	<div class="subject-row mt-20" ng-if="emailInfo.isEmailShown">
								<insert-variable class="insert-variable" [variable-list-type]="'JOB_MENU_SUBJECT'" (on-variable-choose)="addSubjectVariable($event, 'subject-add-template-automation')"></insert-variable>
								<div class="field-info">
									<h4>Subject</h4>
									<div class="flex-row">
										<input id="subject-add-template-automation" ng-disabled="button_disable" type="text" class="form-control" required
											   placeholder="Write an awesome subject line. Why not?" autocomplete="off" maxlength="255"
											   ng-model="newEmailTemplate.subject">
									</div>
								</div>
                            </div>

                            <div class="field-info" ng-if="emailInfo.isEmailShown">
															<h4>Message</h4>
															<sn-quill-editor-web
																[init-value]="newEmailTemplate.text"
																[toolbar-settings]="'variables attachments color size font'"
																[files-obj]="newEmailTemplate.attachmentsData"
																[vars-list]="'JOB_MENU'"
																[editor-i-d]="'wf_plain_email'"
																(on-text-change)="newEmailTemplate.text = $event">
															</sn-quill-editor-web>
														</div>

                            <hr class="mt-30 mb-30">

                        </div>

                `,
			replace: true,
			link(scope) {
				if (typeof scope.emailToSave !== 'undefined') {
					scope.selectedEmail = angular.copy(scope.emailToSave);
					console.log('template here');
				}

				// TODO: move all logic from scope bindings and broadcasts to service
				scope.$on('emailTemplateUpdated', (event, email) => {
					console.log('update');
					scope.selectedEmail = email.id ? angular.copy(email) : null;
					scope.emailToSave = angular.copy(email);
				});

				const emptyAttachmentsData = {
					attachments: [],
					filesSize: 0
				};

				const isUserEmail = email =>
					!email.hasOwnProperty('emailTemplateType') &&
					!email.hasOwnProperty('defaultEmailTemplate');

				function setEmailTemplate(data) {
					scope.selectedEmail = angular.copy(data);
					scope.emailToSave = angular.copy(scope.selectedEmail);
				}

				const showErrorMessage = () => {
					messageService.showToaster('e_0', 'general');
				};

				scope.addNewTemplate = () => {
					scope.newEmailTemplate = {
						name: '',
						text: '',
						attachmentsData: angular.copy(emptyAttachmentsData)
					};
					scope.selectedEmail = null;
					scope.emailToSave = scope.newEmailTemplate;
					scope.emailInfo.isEmailShown = true;

					$('#addAutomationModal').on('shown.bs.modal', () => {
						const input = $(this).find('input');

						validationService.isModalClosePrevented(input);
					});
				};

				scope.addSubjectVariable = function($event, id) {
					const el = document.getElementById(id);
					scope.newEmailTemplate.subject = emailService.addSubjectVariable(
						el,
						$event
					);
				};

				scope.getEmailTemplate = email => {
					scope.emailInfo.isEmailShown = false;

					if (email === null || email === undefined) {
						scope.selectedEmail = null;
						scope.emailToSave = null;
					} else if (email && typeof email === 'object') {
						const isUserEmailChosen = isUserEmail(email);
						if (isUserEmailChosen) {
							scope.selectedEmail = email;
							scope.emailToSave = email;
						} else if (email.id) {
							templateRequestsService
								.getTemplates('full_template', email.id)
								.subscribe(
									data => setEmailTemplate(data),
									error => showErrorMessage()
								);
						}
					} else {
						console.error('no chosen email');
					}
				};

				scope.disableDragDrop = function() {
					return true;
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/Modals/addMailOrTemplate.js